import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["applyValue", "clearValue", "setClose", "enableApplyButton", "enableClearSelectionButton", "enableTodayButton", "onTodayButtonClick", "enableCloseOnSelect"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useCallback } from 'react';
export var useDatePickerActionBar = function useDatePickerActionBar(_ref, ref) {
  var applyValue = _ref.applyValue,
    clearValue = _ref.clearValue,
    setClose = _ref.setClose,
    enableApplyButton = _ref.enableApplyButton,
    enableClearSelectionButton = _ref.enableClearSelectionButton,
    enableTodayButton = _ref.enableTodayButton,
    onTodayButtonClick = _ref.onTodayButtonClick,
    enableCloseOnSelect = _ref.enableCloseOnSelect,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onApplyButtonClick = useCallback(function () {
    applyValue === null || applyValue === void 0 ? void 0 : applyValue();
    setClose === null || setClose === void 0 ? void 0 : setClose();
  }, [applyValue, setClose]);
  var showTodayButton = !!enableTodayButton;
  var showApplyButton = !!enableApplyButton;
  var showClearSelectionButton = !!enableClearSelectionButton;
  var showTodayButtonRegular = showTodayButton && (showApplyButton || showClearSelectionButton);
  var showTodayButtonWide = showTodayButton && !showApplyButton && !showClearSelectionButton;
  var showBar = showTodayButtonRegular || showApplyButton || showClearSelectionButton;
  return {
    rootProps: _objectSpread(_objectSpread({}, restProps), {}, {
      ref: ref
    }),
    getApplyButtonProps: function getApplyButtonProps() {
      return {
        onClick: onApplyButtonClick
      };
    },
    getTodayButtonProps: function getTodayButtonProps() {
      return {
        onClick: function onClick() {
          onTodayButtonClick === null || onTodayButtonClick === void 0 ? void 0 : onTodayButtonClick();
          if (enableCloseOnSelect) {
            setClose === null || setClose === void 0 ? void 0 : setClose();
          }
        }
      };
    },
    getClearSelectionButtonProps: function getClearSelectionButtonProps() {
      return {
        onClick: function onClick() {
          clearValue === null || clearValue === void 0 ? void 0 : clearValue();
          setClose === null || setClose === void 0 ? void 0 : setClose();
        }
      };
    },
    showBar: showBar,
    showApplyButton: showApplyButton,
    showTodayButtonRegular: showTodayButtonRegular,
    showClearSelectionButton: showClearSelectionButton,
    showTodayButtonWide: showTodayButtonWide
  };
};